// This is the entry point for the home component
import React, { FC, useCallback, useContext } from 'react';

// Redux
import { Dispatch } from 'redux';

// Styling
import injectSheet from 'react-jss';
import { FilterRadioHidden } from 'Components/FilterRadioHidden';
import { ProductAnalyticsContext } from 'Context/ProductAnalytics';
import withErrorBoundary from 'HOC/ErrorBoundary';
import styleSheet from './styles';

// Actions
import { setIntendedLevelOfStudyValue } from '../actions/prospectProfile.actions';

// Components

interface Props {
  intendedLevelOfStudy: 'Any' | 'Undergraduate' | 'Graduate';
  dispatch: Dispatch<any>;
  classes: any;
}

const IntendedLevelOfStudyContainer: FC<Props> = (props: Props) => {
  const { intendedLevelOfStudy, dispatch, classes } = props;

  const {
    actions: { filterTrack },
  } = useContext(ProductAnalyticsContext);

  const intendedLevelOfStudyCallback = (event: any) => {
    const { value } = event.target;
    // Combined Analytics Event
    filterTrack({
      filterCategory: 'Prospect Profile',
      filterName: 'Intended Level Of Study',
      filterValue: value,
      addToStore: value,
    });
    setIntendedLevelOfStudyValue(dispatch, value);
  };

  return (
    <div className={classes.container}>
      <FilterRadioHidden
        label="Any"
        value="Any"
        selected={intendedLevelOfStudy === 'Any'}
        identifier="selectionProspectProfileIntendedLevelOfStudy"
        onClick={useCallback(intendedLevelOfStudyCallback, [
          intendedLevelOfStudy,
        ])}
      />
      <FilterRadioHidden
        label="Undergraduate"
        value="Undergraduate"
        selected={intendedLevelOfStudy === 'Undergraduate'}
        identifier="selectionProspectProfileIntendedLevelOfStudy"
        onClick={useCallback(intendedLevelOfStudyCallback, [
          intendedLevelOfStudy,
        ])}
      />
      <FilterRadioHidden
        label="Graduate"
        value="Graduate"
        selected={intendedLevelOfStudy === 'Graduate'}
        identifier="selectionProspectProfileIntendedLevelOfStudy"
        onClick={useCallback(intendedLevelOfStudyCallback, [
          intendedLevelOfStudy,
        ])}
      />
    </div>
  );
};

export default withErrorBoundary(
  injectSheet(styleSheet)(IntendedLevelOfStudyContainer)
);
